import { IExamContentResponse } from '../../../api-refactored/user/useGetIExamMasterCode';

interface usePrCitizenshipFormProps {
  iExamsData?: IExamContentResponse;
}

export const usePrCitizenshipForm = ({ iExamsData }: usePrCitizenshipFormProps) => {
  const renamedPrStatusWithSorting = iExamsData?.prStatus
    .filter(
      (val) =>
        val.codeValueDescription !== 'ALIEN' &&
        val.codeValueDescription !== 'UNKNOWN' &&
        val.codeValueDescription !== 'NOT APPLICABLE'
    )
    .sort((a, b) => (a.codeValueDescription < b.codeValueDescription ? -1 : 1));
  return {
    renamedPrStatusWithSorting,
  };
};
